import { gql } from "@apollo/client";

export const GET_VISITA_CERO_ID = gql`
  query visitaCero($idEvaluacion : Int!) {
    visitaCero(idEvaluacion : $idEvaluacion) {
      idVisita
      idEstado
    }
  }
`;